// This file is auto-generated. Do not edit!

export default [
  {
    address: "0x4200000000000000000000000000000000000006",
    symbol: "WETH",
  },
  {
    address: "0x9A601C5bb360811d96A23689066af316a30c3027",
    symbol: "PIKA",
  },
  {
    address: "0x7F5c764cBc14f9669B88837ca1490cCa17c31607",
    symbol: "USDC",
  },
  {
    address: "0x0b2C639c533813f4Aa9D7837CAf62653d097Ff85",
    symbol: "USDC",
  },
  {
    address: "0x4200000000000000000000000000000000000042",
    symbol: "OP",
  },
  {
    address: "0xdC6fF44d5d932Cbd77B52E5612Ba0529DC6226F1",
    symbol: "WLD",
  },
] as const
